import { Slide } from "@jelly/lesson";

import receiver from "./components/receiver";
import sources from "./components/sources";
import tpa from "./components/tpa";
import states from "./components/states";

const principle: Slide = {
  title: "Powertrain",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Receiver" }, { name: "Sources" }, { name: "TPA" }, { name: "Operational states" }],
          options: {},
        },
      ],
      components: [receiver, sources, tpa, states],
      extraContent: [[]],
    },
  },
};

export default principle;
